import {AiToolImpl} from "@me8eon/aiclient";
import {getGraphApi, ManagerGraphApiResponse} from "../model/api";
import { JwtTokenFn } from "@me8eon/authentication";

type ToolArgs = {
    id: string
}

type ToolImpl = AiToolImpl<ToolArgs>

type Tool = (tokenFn: JwtTokenFn) => ToolImpl

type Executor = (tokenFn: JwtTokenFn) => ToolImpl['execute']

const executor: Executor = (tokenFn) => async (_args, input) => {
    const {id} = input;

    const path = `users/${id}/`;

    const queryParams = {
        "$expand": "manager($levels=1;$select=id,displayName,jobTitle,mail,userPrincipalName,businessPhones,mobilePhone)"
    }

    const response = await getGraphApi<ManagerGraphApiResponse>(path, tokenFn, queryParams)

    const hits = response.data;
    if (!hits.manager || !hits.manager.id ) return {
        value: "No Manager found."
    }

    let phoneInfo = hits.manager.businessPhones && hits.manager.businessPhones.length > 0 ? `Manager Phone: ${hits.manager.businessPhones.join(", ")}\n` : "";
    if(!phoneInfo) {
        phoneInfo = hits.manager.mobilePhone ? `Manager Mobile Phone: ${hits.manager.mobilePhone}\n` : "";
    }
    const managerInfo = `Manager Name: ${hits.manager.displayName}\nManager Email: ${hits.manager.mail}\nManager KID: ${hits.manager.userPrincipalName}\n${phoneInfo}`;

    return {
        value: `Here is the manager info found:\n\n${managerInfo}`
    }
}

export const SearchManagerToolImplGenerator: Tool = (tokenFn) => {
    return {
        type: "graph_api",
        toolDefn: {
            type: 'function',
            name: "search_manager",
            description: "This tool fetches a person's manager ONLY by their principal identifier from GraphAPI platform. It returns a list of person's direct manager and nested hierarchy matching the search query. If no manager is found, it returns 'No Manager found.'.",
            parameters: {
                type: "object",
                required: ["id"],
                additionalProperties: false,
                properties: {
                    id: {
                        type: "string",
                        description: "The principal identifier of the person to find their manager.",
                    }
                },
            },
        },
        execute: executor(tokenFn),
    }
}
